interface Props {
  color?: string;
  width?: string;
  height?: string;
}

function AlertWarning(props: Props) {
  const { color = "#B37014", width = "20", height = "20" } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_12244_11319)">
        <path
          d="M10.0001 19.2863C15.1284 19.2863 19.2858 15.1289 19.2858 10.0006C19.2858 4.8722 15.1284 0.714844 10.0001 0.714844C4.87171 0.714844 0.714355 4.8722 0.714355 10.0006C0.714355 15.1289 4.87171 19.2863 10.0001 19.2863Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99993 5V9.28571M10.7142 13.5714C10.7142 13.9659 10.3944 14.2857 9.99993 14.2857C9.60544 14.2857 9.28564 13.9659 9.28564 13.5714C9.28564 13.1769 9.60544 12.8571 9.99993 12.8571C10.3944 12.8571 10.7142 13.1769 10.7142 13.5714Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12244_11319">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AlertWarning;
